export default __webpack_public_path__ + "static/media/top1-logo.2f785ac1.webp";